export default __webpack_public_path__ + "locales/vi/Translations.json?hash=db24f4c8dc226ace76ad09d19bfbb5eb";